<mat-form-field2 class="mat-block">
  <mat-label i18n>Select what to automate</mat-label>
  <app-select
    [items]="automationTypesConfig"
    bindValue="type"
    [searchable]="true"
    [value]="type"
    [searchCompare]="searchCompare"
    (selectionChange)="changeType($event)"
  >
    <ng-template selectLabel let-items="items">
      <div *ngFor="let item of items" class="d-flex align-items-center gap-1">
        <i [ngClass]="item.icon + ' ' + item.color" class="fa-fw"></i> <span>{{ item.label }}</span>
      </div>
    </ng-template>
    <ng-template selectItem let-item="item">
      <div class="d-flex align-items-center gap-1">
        <i [ngClass]="item.icon + ' ' + item.color" class="fa-fw"></i> <span>{{ item.label }}</span>
      </div>
    </ng-template>
  </app-select>
</mat-form-field2>
